import { useRef, forwardRef, useImperativeHandle } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

const SignaturePad = forwardRef(({ label = "Signature", testId = "signature-pad" }, ref) => {
  const sigRef = useRef(null);

  useImperativeHandle(ref, () => ({
    isEmpty: () => (sigRef.current ? sigRef.current.isEmpty() : true),
    toDataURL: () => (sigRef.current ? sigRef.current.getCanvas().toDataURL("image/png") : null),
    clear: () => sigRef.current && sigRef.current.clear(),
  }));

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">{label}</span>
        <button
          type="button"
          data-testid={`${testId}-clear`}
          onClick={() => sigRef.current && sigRef.current.clear()}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-destructive transition-colors"
        >
          <Eraser className="h-3 w-3" /> Clear
        </button>
      </div>
      <div className="rounded-md border-2 border-dashed border-border bg-white overflow-hidden" data-testid={testId}>
        <SignatureCanvas
          ref={sigRef}
          penColor="#0A0A0A"
          canvasProps={{ className: "w-full h-40 touch-none" }}
        />
      </div>
      <p className="text-xs text-muted-foreground">Sign above using your mouse or finger (touch screen).</p>
    </div>
  );
});

SignaturePad.displayName = "SignaturePad";
export default SignaturePad;
